<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <section class="mu-d-flex">
                <h1 class="mu-mb-00">Process details</h1>
                <details class="mcc-popover mcc-popover--bottom-end" @click="showHelpText = !showHelpText" size="xsm">
                    <summary class="mu-mt-03 mu-ml-02 ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">
                        <p>
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
        </div>
    </div>
    <div class="mcc-container card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Design</li>
                <li v-if="!showProcessBreadCrumb">
                    <a class="table-link" @click="redirectToApplicationList()">Applications</a>
                </li>
                <li v-if="!showProcessBreadCrumb">
                    <router-link @click.native="updateStorage()" :to="CONTEXT_PATH + '/design/applications/' + processAppplication.id">{{processAppplication.name}}</router-link>
                </li>
                <li v-if="showProcessBreadCrumb">
                    <a class="table-link" @click="redirectToProcessList()">Processes</a>

                </li>
                <li aria-current="page">{{applicationProcess.name}}</li>
            </ol>
        </nav>

        <div class="mcc-card mu-p-06">
            
                <div class="mcc-row">
                    <div class="mcc-col">
                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="disableWarning" v-if="applicationProcess.deleted != null" color="warning">
                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                            <p>
                                <strong>Warning!</strong>
                                <br />This process has been disabled and cannot be changed.
                                <br />
                                Reason: {{applicationProcess.deletedReason}}
                            </p>
                        </mcc-alert>

                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="disableAppWarning" v-if="processAppplication.deleted != null" color="warning">
                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                            <p>
                                <strong>Warning!</strong>
                                <br />This process cannot be changed as application has been disabled.
                                <br />
                                Reason: {{processAppplication.deletedReason}}
                            </p>
                        </mcc-alert>
                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="adminProtectedWarning" v-if="processAppplication.protected && !isAdmin" color="warning">
                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                            <p>
                                <strong>Warning!</strong>
                                <br />This application has been protected by an administrator and cannot be edited.
                            </p>
                        </mcc-alert>

                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="protectedWarning" v-if="processAppplication.protected && isAdmin" color="warning">
                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                            <p>
                                <strong>Warning!</strong>
                                <br />This application has been protected.
                            </p>
                        </mcc-alert>

                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning" v-if="isCategoryDeleted == true" color="warning">
                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                            <strong>
                                <p>Warning!</p>
                            </strong>
                            <p>This Process is associated with category which is either deleted or renamed.</p>
                        </mcc-alert>

                    </div>

                </div>

                <div class="mcc-row" v-if="!fetchCall">
                    <div class="mcc-col colSpinner">
                        <div class="spinner-overlay">
                            <div class="spinner-background"></div>
                            <div class="spinner-flex">
                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                </svg>
                            </div>
                        </div>

                    </div>

                </div>
                <div class="mcc-card">
                    <div class="mcc-card__body">
                        <div class="mcc-row" v-if="fetchCall">
                            <div class="mcc-col">
                                <form novalidate id="saveProcessform" @submit.prevent="saveProcess()">
                                    <div style="position:relative">
                                        <div v-if="!updateCall" class="spinner-overlay">
                                            <div class="spinner-background"></div>
                                            <div class="spinner-flex">
                                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                                </svg>
                                            </div>
                                        </div>
                                        <h2 class="mcc-card__title mu-mb-03">Details</h2>
                                        <div class="mt-2 mu-mb-03" v-if="showProcessBreadCrumb" id="applicationId">
                                            <div>
                                                <label class="font-weight-bold">Application</label>
                                            </div>
                                            <router-link :to="CONTEXT_PATH + '/design/applications/' + processAppplication.id">{{processAppplication.name}}</router-link>
                                        </div>

                                        <div class="mfc-input-wrapper mfc-form-input-container mu-mb-03  mfc-form-input-wrapper--width" hidden="" ref="name">
                                            <input type="text" id="name" name="name">
                                        </div>
                                        <div class="mfc-textarea-wrapper mfc-form-input-container mu-mb-03  mfc-form-input-wrapper--width">
                                            <label for="description" class="mu-mb-00">Description</label>
                                            <textarea id="description" @change="updateDescription($event)" name="description" maxlength="100" :disabled="applicationProcess.deleted != null || processAppplication.deleted != null || (processAppplication.protected && !isAdmin) || !processAppplication.editable" :pattern="descRegex" ref="description" placeholder="Description" :value="applicationProcess.description" @input="applicationProcess.description = $event.target.value"></textarea>
                                            <div class="mfc-invalid-feedback"></div>
                                            <div class="mfc-help-text mu-mt-00">
                                                <span class="mfc-help-text" v-if="applicationProcess.description">
                                                    You have {{100 - applicationProcess.description.length}} characters remaining
                                                </span>
                                                <span class="mfc-help-text" v-else>
                                                     You have 100 characters remaining
                                                </span>
                                            </div>
                                        </div>
                                        <div class="mfc-textarea-wrapper mfc-form-input-container mu-mb-03  mfc-form-input-wrapper--width">
                                            <label for="instanceNameTemplate" class="mu-mb-00">Process instance name template</label>
                                            <textarea id="instanceNameTemplate" name="instanceNameTemplate" maxlength="250" :disabled="applicationProcess.deleted != null || processAppplication.deleted != null || (processAppplication.protected && !isAdmin) || !processAppplication.editable" ref="instanceNameTemplate" placeholder="e.g., Absence request for ${firstName} ${surname}" :value="applicationProcess.instanceNameTemplate" @input="applicationProcess.instanceNameTemplate = $event.target.value"></textarea>
                                            <div class="mfc-invalid-feedback"></div>
                                            <div class="mfc-help-text mu-mt-00">
                                                <span class="mfc-help-text">
                                                    Use ${variableName} syntax to insert process variables. Example: "Request for ${firstName} ${surname}"
                                                </span>
                                            </div>
                                        </div>
                                        <div class="mfc-slim-select-wrapper mu-mb-03  mfc-form-input-wrapper--width" v-if="applicationProcess.allVariables!=null && applicationProcess.allVariables.length>0">
                                            <label for="processVarSelect" class="mu-mb-00">Process variables</label>
                                            <select id="processVarSelect" :value="variables" ref="processVarSelect" name="selectedVariables" limit="10" block multiple label="Process variables" help-text="Maximum 10 process variables can be selected" :disabled="processAppplication.deleted != null || applicationProcess.deleted != null || (processAppplication.protected && !isAdmin) || !processAppplication.editable" @change="updateSelectedVariables($event)">
                                                <option v-for="item in applicationProcess.allVariables" :value="item" :key="item">{{item}}</option>
                                            </select>
                                            <div class="mfc-help-text mu-mt-00">
                                                <span>Maximum 10 process variables can be selected</span>
                                            </div>
                                        </div>
                                        <TagInput class=" mfc-form-input-wrapper--width" :labels="labelsNew" :disabled="(processAppplication.protected && !isAdmin) || !processAppplication.editable" ref="labels" />
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03  mfc-form-input-wrapper--width">
                                            <label for="version">Version</label>
                                            <input type="text" id="version" name="version" disabled="" :value="applicationProcess.version" :disabled="!processAppplication.editable">

                                        </div>
                                        <!-- Added primary checkbox button to set process primary -->
                                        <div class="mfc-checkbox-wrapper mfc-form-input-container   mu-mt-03">
                                            <input type="checkbox" id="primary" class="mfc-switch" name="toggleIcon"
                                                :checked="applicationProcess.primary" @change="setIconSet($event.target.checked)" :disabled="!processAppplication.editable">
                                            <label for="coloricon">Primary process</label>
                                        </div>


                                        <IconSelector class="mu-mb-03" v-if="iconFetched" id="processLogoSelect" label="Process logo" :defaultIcon="procIcon" :iconSet="iconSet" @iconUpdate="updateLogo" :disabled="applicationProcess.deleted != null || processAppplication.deleted != null || (processAppplication.protected && !isAdmin) || !processAppplication.editable" />
                                        <div class="mcc-row" v-if="processStartURL">
                                            <div class="mcc-col">
                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03  mfc-form-input-wrapper--width">
                                                    <label for="processStartURL">Process start URL</label>
                                                    <input type="text" readonly="" name="processStartURL" id="processStartURL" :disabled="applicationProcess.deleted != null || processAppplication.deleted != null || (processAppplication.protected && !isAdmin)" @click="handleCopyProcessURLBtn()" :value="processStartURL">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="mcc-row">
                                            <div class="mcc-col">
                                                <div class="mu-d-flex mu-justify-content-end" v-if="!processAppplication.protected || isAdmin">
                                                    <div class="mcc-button-group mcc-button-group--spaced">
                                                        <button type="button" class="mcc-button mcc-button--soft-warning" id="disableBtn" v-if="applicationProcess.deleted == null && processAppplication.deleted == null" @click="handleDisableBtnClick()" title="Disable" :disabled="!processAppplication.editable">
                                                            <mcc-icon name="unavailable" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Disable</span>
                                                        </button>
                                                        <button type="button" class="mcc-button mcc-button--primary" id="enableBtn" v-if="applicationProcess.deleted != null && processAppplication.deleted == null" @click="handleEnableBtnClick()" title="Enable" :disabled="!processAppplication.editable">
                                                            <mcc-icon name="undo" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Enable</span>
                                                        </button>

                                                        <router-link v-if="applicationProcess.deleted == null && processAppplication.deleted == null" :to="CONTEXT_PATH + '/design/applications/' + applicationId+'/appprocesses/create?copyProcessId='+ applicationProcess.id">
                                                            <button class="mcc-button mcc-button--outline mu-mr-05" id="copyBtn" title="Copy" type="button" :disabled="!processAppplication.editable">
                                                                <mcc-icon name="copy" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Copy</span>
                                                            </button>
                                                        </router-link>

                                                        <button class="mcc-button mcc-button--success" title="Save" id="saveBtn" v-if="applicationProcess.deleted == null && processAppplication.deleted == null" type="submit" :disabled="!processAppplication.editable">
                                                            <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                </form>

                            </div>

                        </div>

                    </div>
                </div>

                <div class="mcc-row" v-if="fetchCall">
                    <div class="mcc-col">
                        <div class="mcc-card mt-2">
                            <div class="mcc-card__header mu-d-flex mu-justify-content-between mu-align-items-start mu-flex-wrap">
                                <div>
                                    <h2 class="mcc-card__title  ">Diagram</h2>
                                </div>
                                <div class="mu-d-flex">

                                    <button class="mcc-button mcc-button--primary" title="Edit" id="editDiagramBtn" v-if="processAppplication.deleted == null && applicationProcess.deleted == null && (!processAppplication.protected || isAdmin)" @click="redirectToProcessConfirm()" :disabled="!processAppplication.editable">
                                        <mcc-icon name="edit" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Edit</span>
                                    </button>

                                </div>
                            </div>
                            <div class="mcc-card__body">
                                <div id="oldSvgContainer" v-html="applicationProcess.modelImage" name="modelImage" class="modelImageOverflow"></div>

                            </div>

                        </div>

                    </div>

                </div>
            
        </div>
        <div class="mcc-dialog-overlay">
            <dialog class="mcc-dialog mcc-dialog--warning mcc-dialog--xs" ref="disableDialog" @show="showDisableDialog()" id="disableApplicationProcessModal">
                <form novalidate id="disableApplicationForm">
                    <section>
                        <div class="mcc-dialog__header">
                            <h2 class="h4">Disable</h2>
                            <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                        </div>
                        <div class="mcc-dialog__body">
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <div>
                                        <div class="mfc-textarea-wrapper mb-0 mfc-form-input-container">
                                            <label for="disableReason" class="mfc-label--required">Disable reason</label>
                                            <textarea id="disableReason" name="disableReason" required="" maxlength="100" rows="6" ref="disableReason" :pattern="disableReason" :value="deletedReason" @change="updateReason($event)" @input="deletedReason = $event.target.value"></textarea>
                                            <div class="mfc-invalid-feedback"></div>
                                            <span class="mfc-help-text" v-if="deletedReason">
                                             You have {{100 - deletedReason.length}} characters remaining
                                            <br>
                                            These characters are not allowed: *&amp;$[]{}"/\<>'
                                        </span>
                                        <span class="mfc-help-text" v-else>
                                             You have 100 characters remaining
                                            <br>
                                            These characters are not allowed: *&amp;$[]{}"/\<>'
                                        </span>
                                    </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                        <div class="mcc-dialog__footer">

                            <div class="mcc-button-group mcc-button-group--spaced">
                                <button type="button" class="mcc-button mcc-button--outline" @click="closeDialog()">Close</button>
                                <button type="button" class="mcc-button mcc-button--warning" @click="disableApplicationProcess($event)">Save</button>
                            </div>
                        </div>
                    </section>
                </form>
            </dialog>
        </div>
        <div class="mcc-dialog-overlay">
            <dialog class="mcc-dialog mcc-dialog--warning mcc-dialog--xs" ref="editProcessConfirmationDialog" id="editProcessConfirmationDialog">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Edit process</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.editProcessConfirmationDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row">
                            <div class="mcc-col">This application is protected, do you still want to edit?
                            </div>

                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="$refs.editProcessConfirmationDialog.close()">No</button>
                            <button type="button" class="mcc-button mcc-button--warning" @click="handleEditProcessConfirmDialogClose()">Yes</button>
                        </div>
                    </div>
                </section>
            </dialog>
        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--info mcc-dialog--xs" ref="copyURLDialog" id="share-dialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Share process start URL</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.copyURLDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="">
                        <div class="mfc-input-wrapper mfc-form-input-container" title="Standalone URL"  >
                            <label for="prompt-text-entry">Standalone</label>
                            <div class="mfc-input-group" @click="copyToClipbord(processStartUrlStandalone)">

                                <input type="text" name="prompt-text-entry" readonly="" id="prompt-text-entry" :value="processStartUrlStandalone">
                                <button  type="button" class="mcc-button mcc-button--soft-secondary">Copy</button>

                            </div>
                        </div>
                    </div>
                    <div class="mt-1">
                        <div class="mfc-input-wrapper mfc-form-input-container" title="Integrated URL"  >
                            <label for="prompt-text-entry1">Integrated</label>
                            <div class="mfc-input-group" @click="copyToClipbord(processStartURL)">

                                <input type="text" name="prompt-text-entry1" readonly="" id="prompt-text-entry1" :value="processStartURL">
                                <button  type="button" class="mcc-button mcc-button--soft-secondary">Copy</button>


                            </div>
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--info" @click="$refs.copyURLDialog.close()">Close</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
</div>
</template>

<script>
import ApplicationProcessAPI from "../../../services/ApplicationProcessAPI";
import {
    EventBus
} from "../../../services/event-bus";
import msgConstants from "../../../messages";
import Utils from "../../../script_utils";
import IconSelector from "../../customComponents/IconSelector"
import CONSTANTS from '../constant.js'
import TagInput from "../../common/TagInput.vue";
import {
    displayErrorMessage,
    checkFormAndTextareaValidations
} from '../../../formvalid';

export default {
    name: "ApplicationProcessEdit",
    components: {
        IconSelector,
        TagInput
    },
    data() {
        return {
            applicationProcess: {},
            processAppplication: {
                id: "",
                name: "",
                protected: false
            },
            updateCall: false,
            descRegex: msgConstants.PATTERNS["description"],
            disableReason: msgConstants.PATTERNS["disableReason"],
            applicationId: this.$route.params.appId,
            fetchCall: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            labelsNew: [],
            deletedReason: "",
            isAdmin: false,
            source: "",
            sourceMenuVal: "",
            isCategoryDeleted: false,
            processStartURL: "",
            processStartUrlStandalone: "",
            helpText: msgConstants.BREADCRUMB_HELP["application.process.edit"],
            showHelpText: false,
            showProcessBreadCrumb: false,
            variables: [],
            procIcon: '',
            iconSet: '',
            iconFetched: false,
            dataLoaded: false,
            updateDisableCall: false,
            selectInstanceEntities: null,
            isDescriptionValid: true,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        this.showProcessBreadCrumb = this.$route.query.hasOwnProperty("path");
        let self = this;
        self.loadInitialData();
    },
    watch: {
    'applicationProcess.modelImage'() {
      this.$nextTick(() => {
        this.setViewBoxForSVG();
      });
    }
  },

    methods: {
        setViewBoxForSVG() {
      const svgElement = this.$el.querySelector('#oldSvgContainer svg');
      if (svgElement) {
        const bbox = svgElement.getBBox(); 
            svgElement.setAttribute('viewBox', `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`);
      }
    },
        updateReason(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.disableReason), "Disable reason is required")
                self.$refs.disableReason.classList.add("ms-is-invalid")
                self.invalidDisableReason = true;
            } else if (!event.target.value.match(this.disableReason)) {
                displayErrorMessage($(self.$refs.disableReason), "Disable reason must be valid")
                self.$refs.disableReason.classList.add("ms-is-invalid")
                self.invalidDisableReason = true;
            } else {
                self.$refs.disableReason.classList.remove("ms-is-invalid")
                self.invalidDisableReason = false;
            }
            self.deletedReason = event.target.value;
        },
        updateDescription(event) {
            let self = this;
            if (!event.target.value.match(this.descRegex) && event.target.value != "") {
                displayErrorMessage($(self.$refs.description), "Description must be valid")
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            } else {
                self.$refs.description.classList.remove("ms-is-invalid")
                self.isDescriptionValid = true;
            }
        },
        loadInitialData() {
            let self = this;
            ApplicationProcessAPI.getProcessDetails(
                    this.$route.params.appId,
                    this.$route.params.processId
                )
                .then(function (result) {
                    if (result == null) {
                        self.$router.push(
                            self.CONTEXT_PATH + "/design/applications"
                        );
                        EventBus.$emit('error-notification', {
                            "msg": "Error while fetching application process"
                        });
                        return;
                    }
                    self.dataLoaded = true;
                    let data = result.data;
                    self.applicationProcess = data.applicationProcess;
                    self.processAppplication = data.applicationProcess.processApplication;
                    self.fetchCall = true;
                    if (self.applicationProcess.allVariables != null && self.applicationProcess.allVariables.length > 0) {
                        setTimeout(() => {
                            self.selectInstanceEntities = new SlimSelect({
                                select: '#processVarSelect',
                                settings: {
                                    closeOnSelect: false,
                                    maxSelected: 10,
                                },
                            })
                            self.selectInstanceEntities.setSelected(data.applicationProcess.selectedVariables);
                        });
                    }
                    if (data.applicationProcess.labels != null && data.applicationProcess.labels != "") {
                        let labelsArray = data.applicationProcess.labels.split(",");
                        labelsArray.forEach(element => {
                            self.labelsNew.push(element);
                        });
                    }

                    self.isAdmin = data.isAdmin;
                    self.source = data.source;
                    self.sourceMenuVal = data.sourceMenuVal;
                    self.isCategoryDeleted = data.isCategoryDeleted;

                    if (data.processStartURL && data.processStartURL != "") {
                        self.processStartURL = window.location.origin + self.CONTEXT_PATH +
                            data.processStartURL.substring(data.processStartURL.indexOf("/processes"),
                                data.processStartURL.length);

                        self.processStartUrlStandalone = window.location.origin + self.CONTEXT_PATH +
                            "/standalone/external" +
                            self.processStartURL.substring(self.processStartURL.indexOf("/processes"),
                                self.processStartURL.length) + "." + Buffer.from(self.applicationProcess.processApplication.tenantId).toString('base64');
                    }
                    self.variables = data.applicationProcess.selectedVariables.join(",");

                    if (self.applicationProcess.processLogo != null && self.applicationProcess.processLogo.indexOf(':') != -1) {
                        let procLogo = self.applicationProcess.processLogo.split(':');
                        self.procIcon = procLogo[0];
                        self.iconSet = (procLogo.length > 1 && procLogo[1] != '') ? 'fluency-color' : ''
                    }

                    let pageTitle = msgConstants.PAGEHEADER_TITLE["menu.process.details"] + " - " + self.applicationProcess.name;
                    EventBus.$emit("update-pageTitle", pageTitle);
                })
                .finally(() => {
                    if (self.dataLoaded) {
                        self.fetchCall = true;
                        self.iconFetched = true;
                        if (self.$refs.processVarSelect != null) {
                            self.$refs.processVarSelect.value = self.variables;
                        }
                        self.updateSVG();
                        self.updateCall = true;
                        self.updateTagsDisabledState();
                    }
                });
            },
        async updateTagsDisabledState() {
            await this.$nextTick();
            if (this.applicationProcess.deleted != null || this.processAppplication.deleted != null ||
                (this.processAppplication.protected && !this.isAdmin)) {
                let self = this;
                setTimeout(function () {
                    if ($(self.$refs.labels).length > 0) {
                        $(self.$refs.labels)[0].disabled = true;
                    }
                }, 0)
            }
        },
        closeDialog() {
                let form = $('#disableApplicationForm')
                form[0].classList.remove("ms-was-validated");
                this.$refs.disableDialog.close()
                this.updateDialog = false;
    
            },
        updateLogo(obj) {
                this.applicationProcess.processLogo = obj.icon + ':' + obj.iconSet;
            },
        handleCopyProcessURLBtn() {
            let self = this;
            let isDisabled = self.applicationProcess.deleted != null || self.processAppplication.deleted != null || (self.processAppplication.protected && !self.isAdmin);
            if (!isDisabled) {
                this.$refs.copyURLDialog.show();
            }
        },
        copyToClipbord(text) {
            navigator.clipboard.writeText(text)
            EventBus.$emit("success-notification", {
                msg: "URL copied to clipboard"
            });
        },
        async updateSVG() {
            await this.$nextTick();
            Utils.updateSVG("oldSvgContainer");
        },
        saveProcess() {
            let self = this;
            let form = $('#saveProcessform')
            if(!self.isDescriptionValid){
                return;
            }

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            let newProcessObj = {};
            let selectorValue = $("#selector").val();

            newProcessObj.id = this.applicationProcess.id;
            newProcessObj.name = this.applicationProcess.name;
            newProcessObj.description = this.applicationProcess.description;
            newProcessObj.labels = this.applicationProcess.labels;
            // set primary variable based on API response
            newProcessObj.primary = this.applicationProcess.primary;
            newProcessObj.processLogo = this.applicationProcess.processLogo ? this.applicationProcess.processLogo : "";
            newProcessObj.instanceNameTemplate = this.applicationProcess.instanceNameTemplate;
            if (self.$refs.processVarSelect != null) {
                newProcessObj.selectedVariables = this.selectInstanceEntities.getSelected();
            }
            self.applicationProcess.labels = this.$refs.labels.value;
            newProcessObj.labels = this.$refs.labels.value;
            self.updateCall = false;
            ApplicationProcessAPI.saveProcess(
                    this.$route.params.appId,
                    this.applicationProcess.id,
                    newProcessObj,
                    false
                )
                .then(response => {
                    if (response != undefined) {
                        if (response.error) {
                            for (let k in response.messages) {
                                if (k == "labels") {
                                    displayErrorMessage($('#tags'), msgConstants.MESSAGES[response.messages[k]])
                                    $('#tags')[0].classList.add('ms-is-invalid')
                                    $('.mfc-tags-input')[0].classList.add('ms-is-invalid')
                                } else {
                                    EventBus.$emit("error-notification", {
                                        msg: msgConstants.MESSAGES[response.message]
                                    });
                                }
                            }
                        } else {
                            self.applicationProcess = response.data;
                            self.variables = response.data.selectedVariables;
                            if (self.selectInstanceEntities != null) {
                                self.selectInstanceEntities.setSelected(self.variables);
                            }
                            setTimeout(() => {
                                EventBus.$emit("success-notification", {
                                    msg: msgConstants.MESSAGES[response.message]
                                });
                            }, 1000);
                        }
                    }

                })
                .finally(() => {
                    setTimeout(() => {
                        self.updateCall = true;
                    }, 1500);
                });
        },
        handleDisableBtnClick() {
            this.deletedReason = "";
            this.$refs.disableReason.classList.remove("ms-is-invalid")
            this.$refs.disableDialog.show();
        },
        disableApplicationProcess(e) {
           
            let form = $('#disableApplicationForm')

            if(!checkFormAndTextareaValidations('disableReason',this.disableReason,form))
            {
                return;
            }
            let self = this;
            return ApplicationProcessAPI.disableApplicationProcess(
                self.applicationId,
                self.applicationProcess.id,
                self.deletedReason
            ).then(response => {
                if (!response.error) {
                    EventBus.$emit("success-notification", {
                        msg: msgConstants.MESSAGES[response.message]
                    });
                    self.$router.push(
                        self.CONTEXT_PATH +
                        "/design/applications/" +
                        this.$route.params.appId
                    );
                }
            });
        },
        handleEnableBtnClick() {
            let self = this;
            self.fetchCall = false;
            return ApplicationProcessAPI.enableApplicationProcess(
                    self.applicationId,
                    self.applicationProcess.id
                )
                .then(response => {
                    if (!response.error) {
                        self.applicationProcess.deleted = null;
                        self.applicationProcess.deletedReason = null;
                        self.applicationProcess.version = response.data.version;
                        EventBus.$emit("success-notification", {
                            msg: msgConstants.MESSAGES[response.message]
                        });
                    }
                })
                .finally(() => {
                    self.fetchCall = true;
                    if (self.applicationProcess.allVariables != null && self.applicationProcess.allVariables.length > 0) {
                        setTimeout(() => {
                            self.selectInstanceEntities = new SlimSelect({
                                select: '#processVarSelect',
                                settings: {
                                    closeOnSelect: false,
                                    maxSelected: 10,
                                },
                            })
                            self.selectInstanceEntities.setSelected(self.applicationProcess.selectedVariables);
                        });
                    }
                });
        },
        showDisableDialog() {
            this.updateDisableCall = true;
        },
        closeDisableDialog() {
            this.updateDisableCall = false;
        },
        redirectToProcessConfirm() {
            if (!this.processAppplication.protected) {
                localStorage.setItem('processName', this.applicationProcess.name);
                localStorage.setItem('modelXML', this.applicationProcess.modelXML);
                localStorage.setItem('helpUrlLink', this.$store.getters.getHelpUrl);
                this.$router.push({
                    path: `${this.CONTEXT_PATH}/applications/` + this.applicationId + '/appprocesses/' + this.$route.params.processId + '/modeller'
                })
            } else {
                $("#editProcessConfirmationDialog")[0].show();
            }
        },
        handleEditProcessConfirmDialogClose(e) {
            localStorage.setItem('processName', this.applicationProcess.name);
            localStorage.setItem('modelXML', this.applicationProcess.modelXML);
            localStorage.setItem('helpUrlLink', this.$store.getters.getHelpUrl);
            this.$router.push({
                path: `${this.CONTEXT_PATH}/applications/` + this.applicationId + '/appprocesses/' + this.$route.params.processId + '/modeller'
            })
        },
        redirectToApplicationList() {
            localStorage.setItem("application", "application");

            this.$router.push(
                this.CONTEXT_PATH + '/design/applications'
            );
        },
        updateStorage() {
            localStorage.setItem(CONSTANTS.PROCESSLIST, CONSTANTS.PROCESSLIST);
            localStorage.setItem(CONSTANTS.FORMLIST, CONSTANTS.FORMLIST);
        },
        redirectToProcessList() {
            localStorage.setItem(CONSTANTS.PROCESSLIST, CONSTANTS.PROCESSLIST);

            this.$router.push(
                this.CONTEXT_PATH + '/design/applications/appprocesses'
            );
        },
        // Method to set the icon set for the process
        // This will be used to set the primary process icon set
        setIconSet(isChecked) {
            this.applicationProcess.primary = isChecked;
        },
    
    }
}
</script>
<style scoped>
@import "../../../assets/css/symbol.css";
</style>
<style>
.modelImageOverflow {
    overflow-x: auto;
}

#labelTag .mc-tags-input__container {
    width: 40% !important;
}

.mc-forms__valid-feedback {
    display: none;
}

.mc-forms__invalid-feedback {
    display: none;
}


</style>
